import { createTag } from '@common/dynamic-loader';
import getToken, { parseJwt } from '@util/auth-token';
import { getCookie } from '@util/cookies';

import './styles/userpilot.css';

export const loadUserpilot = async () => {
  if (getCookie('Cypress')) return null;

  const token = await getToken();
  const userType = parseJwt(token)?.utype;
  if (userType && userType !== 'Student') {
    window.userpilotSettings = { token: 'NX-100lo56x6' };

    /**
     * First, let's see if userpilot is already on the page:
     */
    if (window.top?.userpilot) {
      return window.top.userpilot;
    }

    /**
     * If not, let's try to load it.
     */
    // eslint-disable-next-line no-useless-catch
    try {
      await createTag('script', {
        async: true,
        src: 'https://js.userpilot.io/sdk/latest.js'
      });

      if (window.top?.userpilot) {
        return window.top.userpilot;
      }
    } catch (e) {
      /**
       * If we want, we can report loading errors
       * to sentry.
       */
      throw e;
    }
  }
};

export const rightsToUserpilot = rights => {
  return rights.reduce((acc, right) => ({ ...acc, [right.rightName]: true }), {});
};

export const licensesToUserpilot = licenses => {
  return licenses.reduce((acc, license) => {
    if (license.hasLicense && license.valid) {
      return { ...acc, [`license_${license.applicationId}`]: true };
    }
    return acc;
  }, {});
};
